import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'antd';
import VerticalBox from '../../../shared/components/basic/VerticalBox';
import { Box, ShowIf, Text } from '../../../shared/components';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';

import Theme from '../../../../theme';
import ArticuloImagenLoader from './ArticuloImagenLoader.datadisplay';
import {autoFormatCurrency} from "../../../../helpers/common.helper";

const primaryColor = Theme.colors.primary;

const ArticuloFotoGridBox = ({
  articulo,
  articulo: {
    id: articuloId, pvp: precio, descripcion: nombre, codigo,
    stock_tienda_actual: stock, stock_global: stockGlobal,
  }, photoSrc, onClick, style, selected, onVRClick,
}) => {
  let unidades = null;
  if (stock) {
    unidades = stock.unidades_propias;
  }
  const cadenaStock = `${unidades} ud.`;
  return (
    <Box
      style={{ ...style }}
      display="inline-block"
    >
      <Card
        style={{
          display: 'inline-block',
          width: '100%',
          overflow: 'hidden',
          outline: (selected) ? `2px solid ${primaryColor}` : '0px solid transparent',
          borderColor: (selected) ? primaryColor : '#D9D9D9',
        }}
        bodyStyle={{ height: '100%', padding: '8px' }}
      >
        <VerticalBox
          style={{ height: '170px', cursor: 'pointer' }}
          onClick={() => onClick({ articuloId, nombre, precio })}
        >
          <ArticuloImagenLoader articulo={articulo} />
        </VerticalBox>
        <ShowIf condition={typeof onVRClick == 'function'}>
          <Button
            style={{ padding: '0px 8px' }}
            onClick={() => {
              onVRClick({ articuloId, nombre, precio });
            }}
          >
            VR
          </Button>
        </ShowIf>
      </Card>

      <TwoColumnsFlexLayout
        mt="8"
        leftColumnStyle={{ minWidth: 0 }}
        flexLeft={4}
        leftContent={(
          <Text
            style={{
              maxWidth: '100%',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
            color="black"
          >
            {nombre}
          </Text>
        )}
        rightContent={(
          <Text style={{ display: 'block' }} color="black" fontWeight="semibold" textAlign="right">
            {autoFormatCurrency(precio)}
          </Text>
        )}
      />

      <TwoColumnsFlexLayout
        leftColumnStyle={{ minWidth: 0 }}
        flexLeft={4}
        leftContent={(
          <Text
            style={{
              maxWidth: '100%',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
            mt="8"
            fontSize={12}
            color="grey"
          >
            {codigo}
          </Text>
        )}
        rightContent={(
          <Text fontSize={12} mt="8" style={{ display: 'block' }} color="primary" textAlign="right">
            {cadenaStock}
          </Text>
        )}
      />

    </Box>
  );
};

ArticuloFotoGridBox.propTypes = {
  articulo: PropTypes.any,
  photoSrc: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

ArticuloFotoGridBox.defaultProps = {
  articulo: {},
  precio: undefined,
  photoSrc: undefined,
  selected: false,
  onClick: () => { },
};
export default ArticuloFotoGridBox;
